import { render } from "./form-container.vue?vue&type=template&id=3bd8c75c&scoped=true"
import script from "./form-container.vue?vue&type=script&lang=js"
export * from "./form-container.vue?vue&type=script&lang=js"

import "./form-container.vue?vue&type=style&index=0&id=3bd8c75c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd8c75c"]])

export default __exports__